/**
 * Different types of ViewSettings.
 * @public
 */
enum ViewSettingsDialogMode {
	/**
	 * Default type
	 * @since 1.0.0-rc.16
	 * @public
	 */
	Sort = "Sort",

	/**
	 * Filter type
	 * @since 1.0.0-rc.16
	 * @public
	 */
	Filter = "Filter",

	/**
	 * Group type
	 * @since 2.13.0
	 * @public
	 */
	Group = "Group",
}

export default ViewSettingsDialogMode;
